import { type CoreBundleItemPayload } from '@flecto/types'
import { useModal } from '@flecto/ui'

import { ModalBundleItemsLocation } from '../components/ModalBundleItemsLocation/ModalBundleItemsLocation'

type UseModalBundleItemsLocationProps = {
  bundleItems?: CoreBundleItemPayload[]
}

export function useModalBundleItemsLocation() {
  return useModal<UseModalBundleItemsLocationProps>({
    modalComponent: (props) => (
      <ModalBundleItemsLocation bundleItems={props?.bundleItems} />
    ),
  })
}
